module.exports = __webpack_public_path__ + "img/pro-xtslider5.819f7df2.png";